export enum ReferenceLineIndex {
	SPAN = 1,
	EVENT = 2,
	METRIC_LINE = 4,
	SPAN_LABEL = 1,
	EVENT_LABEL = 6,
	METRIC_LINE_LABEL = 7
}